var App = App || {};

App.BulletBasedPromoBand = (function ($) {
    "use strict";

    var bbBands = $(".component.component-bb-promo-band.gif");

    function init() {
        bbBands.each(function () {
            var bbbID = $(this).attr("data-img-id");
            var controls = $(this).find(".bbb-img-control");
            const gif = new Freezeframe('#' + bbbID, {
                trigger: false
            });

            controls.on("click", function () {
                $(this).toggleClass("hidden");
                $(this).siblings().toggleClass("hidden");
                gif.toggle();
            });

            //allow gif to be playing when first encountered
            var initialStart = false;
            var windowHeight, imgTop, imgBottom = null;
            $(window).scroll(function () {
                windowHeight = $(window).innerHeight();
                imgTop = gif.$images[0].getBoundingClientRect().top;
                imgBottom = gif.$images[0].getBoundingClientRect().top + gif.$images[0].offsetHeight;

                if (imgTop <= windowHeight && imgBottom >= 0) { //if  gif is on screen
                    if (!initialStart && $(gif.$images[0]).parent().hasClass("ff-inactive")) { //if gif is ready to start and hasn't been already
                        gif.start();
                        initialStart = true;
                    }
                }
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BulletBasedPromoBand.init();
});